export const PRODUCT_NAME = 'harvester';
export const BLANK_CLUSTER = '_';
export const LOGO = require(`@shell/assets/images/providers/harvester.svg`);
